import React from "react";
import { getI18NMessage } from "./../../../i18n/I18N";
import UI_CONSTANTS from "./../../app/constants/UIConstants";

class LoginFooter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="lg-footer">
        {this.props.config.map(footerItem => this.getFooterItem(footerItem))}
      </div>
    );
  }

  getFooterItem(config) {
    if (config.id === UI_CONSTANTS.TERMS_AND_CONDITIONS) {
      return (
        <div className="terms-and-consitions" key={config.id}>
          {getI18NMessage("termsprefix").replace(
            "#companyname#",
            config.companyname
          )}
          {" "}<a href={config.terms}>{getI18NMessage("termslink")}</a>{" "}
          {getI18NMessage("termsmiddle")}
          {" "}<a href={config.privacy}>{getI18NMessage("privacylink")}</a>{" "}.
        </div>
      );
    }
  }
}

export default LoginFooter;
